@if (!isExpanded()) {
  <procure-menu [isExpanded]="false">
    @if (insights()) {
      <procure-menu-item
        icon="info"
        label="Insights"
        (click)="expandPanel(Views.Insights)"
      />
    }
    @if (copilot()) {
      <procure-menu-item
        label="Copilot"
        [icon]="aiIcon"
        (click)="expandPanel(Views.Copilot)"
      />
    }
    @if (documents()) {
      <procure-menu-item
        label="Documents"
        icon="mail"
        (click)="expandPanel(Views.Documents)"
      />
    }
    @if (parsedData()) {
      <procure-menu-item
        label="Parsed Data"
        icon="info"
        (click)="expandPanel(Views.ParsedData)"
      />
    }
  </procure-menu>
} @else {
  <div
    class="views"
    [class.has-view-toggle]="hasMultipleViews()"
  >
    @if (hasMultipleViews()) {
      <div class="view-toggle-container">
        <mat-button-toggle-group
          class="view-toggle"
          [formControl]="viewControl"
        >
          @if (insights()) {
            <mat-button-toggle
              class="view-toggle-button"
              [value]="Views.Insights"
            >
              Insights
            </mat-button-toggle>
          }
          @if (copilot()) {
            <mat-button-toggle
              class="view-toggle-button"
              [value]="Views.Copilot"
            >
              Copilot
            </mat-button-toggle>
          }
          @if (documents()) {
            <mat-button-toggle
              class="view-toggle-button"
              [value]="Views.Documents"
            >
              Documents
            </mat-button-toggle>
          }
          @if (parsedData()) {
            <mat-button-toggle
              class="view-toggle-button"
              [value]="Views.ParsedData"
            >
              Parsed Data
            </mat-button-toggle>
          }
        </mat-button-toggle-group>
      </div>
    }
    <div class="content">
      @switch (activeView()) {
        @case (Views.Insights) {
          <ng-container
            *ngTemplateOutlet="insights()"
            hidden
          />
        }
        @case (Views.Copilot) {
          <ng-container
            *ngTemplateOutlet="copilot()"
            hidden
          />
        }
        @case (Views.Documents) {
          <ng-container
            *ngTemplateOutlet="documents()"
            hidden
          />
        }
        @case (Views.ParsedData) {
          <ng-container
            *ngTemplateOutlet="parsedData()"
            hidden
          />
        }
      }
    </div>
  </div>
}
<procure-resize-handler
  placement="right"
  (mousedown)="startResizing($event)"
/>
<procure-sidenav-toggle-button
  placement="right"
  [isExpanded]="isExpanded()"
  (click)="toggleExpansion()"
/>

<ng-template #aiIcon>
  <img [src]="'/assets/icons/ai/logo.svg' | fileHash" />
</ng-template>
